import dayjs, { Dayjs } from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import { SellerReportPeriod } from "services/interface/sellerReport.interface";

// BBBB = ปี พ.ศ. 4 หลัก, BB = 2 หลัก (dayjs กันการ extend ซ้ำให้อยู่แล้ว)
dayjs.extend(buddhistEra);

/** บังคับ locale ไทยที่ instance เอง ไม่พึ่ง dayjs.locale('th') ที่ตั้ง global ไว้ใน index.tsx */
const th = (value?: dayjs.ConfigType): Dayjs => dayjs(value).locale("th");

/**
 * ช่วงวันที่ของแต่ละ period — ต้องตรงกับ getPeriodWindow() ใน
 * bangbow-api-v2/src/routers/factory/seller-report.service.ts เป๊ะ ๆ
 * ไม่งั้น label ที่โชว์จะไม่ตรงกับข้อมูลที่ backend คำนวณ
 */
export const getPeriodRange = (period: SellerReportPeriod): [Dayjs, Dayjs] => {
  const today = th();
  if (period === "year") return [today.startOf("year"), today];
  const days = period === "30d" ? 30 : 7;
  return [today.subtract(days - 1, "day"), today];
};

/**
 * "5–11 กันยายน 2569" (เดือนเดียวกัน)
 * "28 ส.ค. – 11 กันยายน 2569" (ปีเดียวกัน)
 * "1 ธ.ค. 2568 – 15 ก.ย. 2569" (คนละปี)
 */
export const formatThaiDateRange = (start: Dayjs, end: Dayjs): string => {
  const s = start.locale("th");
  const e = end.locale("th");
  if (s.isSame(e, "month")) return `${s.format("D")}–${e.format("D MMMM BBBB")}`;
  if (s.isSame(e, "year")) return `${s.format("D MMM")} – ${e.format("D MMMM BBBB")}`;
  return `${s.format("D MMM BBBB")} – ${e.format("D MMM BBBB")}`;
};

/** label ของปุ่มเลือกช่วงเวลามุมขวาบน */
export const formatPeriodLabel = (period: SellerReportPeriod): string => {
  const [start, end] = getPeriodRange(period);
  return formatThaiDateRange(start, end);
};

/** แกน X ของกราฟ: "2026-09-05" → "5 ก.ย." | "2026-09" → "ก.ย. 69" */
export const formatTrendAxisLabel = (label: string, period: SellerReportPeriod): string => {
  if (!label) return "";
  return period === "year" ? th(`${label}-01`).format("MMM BB") : th(label).format("D MMM");
};

/** tooltip ของกราฟ: "2026-09-05" → "5 กันยายน 2569" */
export const formatTrendTooltipLabel = (label: string, period: SellerReportPeriod): string => {
  if (!label) return "";
  return period === "year" ? th(`${label}-01`).format("MMMM BBBB") : th(label).format("D MMMM BBBB");
};

/** "อัปเดตล่าสุด 14:32 น." — ว่างเปล่าถ้ายังไม่เคยโหลดสำเร็จ */
export const formatUpdatedAt = (timestamp?: number): string =>
  timestamp ? `อัปเดตล่าสุด ${th(timestamp).format("HH:mm")} น.` : "";
